document.addEventListener("DOMContentLoaded",()=>{

const section = document.querySelector(".hub-cta__content");

if(!section) return;

section.style.opacity="0";
section.style.transform="translateY(40px)";
section.style.transition="all .8s ease";

const observer = new IntersectionObserver(entries=>{
entries.forEach(entry=>{
if(entry.isIntersecting){
section.style.opacity="1";
section.style.transform="translateY(0)";
}
});
},{threshold:.3});

observer.observe(section);

});